import axios from "axios";

export const create = (requestParams, formData, callback) => {
  var promise = axios({
    method: 'post',
    url: Routes.corporate_agreement_documents_path({'format': 'json'}),
    data: formData,
    headers: {
      "X-CSRF-TOKEN": window.compliance.token
    }
  });

  promise
    .then(response => {
      callback(response);
    })
    .catch(error => {
      callback(error.response);
    });
}

export const update = (id, formData, callback) => {
  var promise = axios({
    method: 'PATCH',
    url: Routes.corporate_agreement_document_path(id, { format: "json" }),
    data: formData,
    headers: {
      "X-CSRF-TOKEN": window.compliance.token,
    },
  });

  promise
    .then(response => {
      callback(response);
    })
    .catch(error => {
      callback(error.response);
    });
};

export const index = (filterRequestParams , callback) => {
  var promise = axios({
    method: 'get',
    url: Routes.corporate_agreement_documents_path({ ...{...filterRequestParams}, format: "json", _options: true}),
    headers: {
      "X-CSRF-TOKEN": window.compliance.token,
    },
  });

  promise
    .then(response => {
      callback(response);
    })
    .catch(error => {
      callback(error.response);
    });
};

export const getByIds = (requestParams, formData, callback) => {
  var promise = axios({
    method: 'post',
    url: Routes.get_by_ids_corporate_agreement_documents_path({...{...requestParams}, format: "json" }),
    data: formData,
    headers: {
      "X-CSRF-TOKEN": window.compliance.token,
    },
  });

  promise
    .then(response => {
      callback(response);
    })
    .catch(error => {
      callback(error.response);
    });
};
